export const featureFlags = {
  groupNotifications: process.env.REACT_APP_FEATURE_GROUP_NOTIFICATIONS === 'true',
  activeCircumstanceNotifiable: process.env.REACT_APP_ACTIVE_CIRCUNSTANCE_NOTIFIABLE === 'true',
} as const;

export type FeatureFlagKey = keyof typeof featureFlags;